import { render } from "./mobile-partner-nav.vue?vue&type=template&id=481a7f9e"
import script from "./mobile-partner-nav.vue?vue&type=script&lang=js"
export * from "./mobile-partner-nav.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__